import { useEffect, useState } from 'react';
export function useInAppBrowser() {
  const [isInAppBrowser, setIsInAppBrowser] = useState(false);
  useEffect(() => {
    const matches = window.navigator.userAgent.match(/Todoist-(Android|iOS)/);
    setIsInAppBrowser(matches !== null && matches.length > 0);
  }, []);
  return isInAppBrowser;
}